import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { mainList, delMain, mainCopy, mainStatusV2 } from './request';
import { unitResource } from './../underwritingManage/request';
import { agencyResource } from './../organizationalManage/request';
import { insuranceClassResource } from '../classManage/request';
import { intermediaryResource } from '../agencyManage/request';
import informationModel from '@/views/template/components/informationModel';
export default {
  components: {
    informationModel
  },
  data() {
    const h = this.$createElement;
    return {
      showItem: false,
      form: {
        agencyId: undefined
      },
      data: [],
      unitList: [],
      intermediaryList: [],
      columns: [{
        slots: {
          title: '产品标识'
        },
        dataIndex: 'mark',
        key: '1',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '承保单位'
        },
        dataIndex: 'unitName',
        key: '2',
        align: 'center',
        scopedSlots: {
          customRender: 'unitName'
        },
        ellipsis: true,
        customRender: (text, record) => h("a-tooltip", {
          "attrs": {
            "placement": "topLeft",
            "title": record.unitName
          }
        }, [record.unitName])
      }, {
        slots: {
          title: '承保机构'
        },
        dataIndex: 'agencyName',
        key: 'description',
        align: 'center',
        scopedSlots: {
          customRender: 'agencyName'
        },
        ellipsis: true,
        customRender: (text, record) => h("a-tooltip", {
          "attrs": {
            "placement": "topLeft",
            "title": record.agencyName
          }
        }, [record.agencyName])
      }, {
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        slots: {
          title: '产品名称'
        }
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        },
        width: 100
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '8',
        align: 'center'
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 120
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      time: [],
      insuranceClassList: [],
      intermediarySelectList: [],
      informationShow: false
    };
  },
  created() {
    unitResource({}).then(res => {
      this.unitList = res;
    });
    insuranceClassResource({}).then(res => {
      this.insuranceClassList = res.items;
    });
    intermediaryResource({
      type: 0
    }).then(res => {
      this.intermediarySelectList = res;
    });
    this.agencyFun();
    this.getDataFun();
  },
  mounted() {
    console.log(this);
  },
  methods: {
    reset() {
      this.form = {
        agencyId: undefined
      };
      this.time = [];
      agencyResource({
        unitId: undefined
      }).then(res => {
        this.intermediaryList = res;
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      mainList(obj).then(res => {
        console.log(res);
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    onChange(e) {
      this.form.startAt = e.length ? e[0] : '';
      this.form.endAt = e.length ? e[1] : '';
      console.log(e);
    },
    agencyFun() {
      this.form.agencyId = undefined;
      agencyResource({
        unitId: this.form.unitId
      }).then(res => {
        this.intermediaryList = res;
      });
    },
    agencyChange(val) {
      this.form.agencyId = val;
      let arr = this.intermediaryList.filter(item => item.id == val);
      this.form.unitId = arr.length != 0 ? arr[0].unitId : undefined;
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该主险') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delMain({
          insuranceIds: val.insuranceId
        }).then(res => {
          _this.$message.success(_this.$t('操作成功') + '!');
          _this.getDataFun();
        });
      });
    },
    handleCopy(val) {
      mainCopy({
        insuranceId: val.insuranceId
      }).then(res => {
        this.$message.success(this.$t('操作成功') + '!');
        this.getDataFun();
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    checkedFun(val) {
      if (!this.isAuth('home.insuranceStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      mainStatusV2({
        insuranceId: val.insuranceId,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        if (res.length != 0) {
          console.log(res);
          this.informationShow = true;
          this.$nextTick(() => {
            console.log(this.$refs.infoRef);
            this.$refs.infoRef.init(res, 7);
          });
        } else {
          this.$message.success(this.$t('修改成功') + '!');
          this.getDataFun();
        }
      });
    }
  }
};